'use strict';

function CompanyPublicationCompanyOrderService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/publications/:publicationId/orders/:orderId', {}, {
    'update': {
      method: 'PUT'
    },
    'updateItems':  {
      url: config.apiBase + '/companies/:companyId/publications/:publicationId/orders/:orderId/items',
      method: 'POST'
    },
    'updateItem':  {
        url: config.apiBase + '/companies/:companyId/publications/:publicationId/orders/:orderId/items/:itemId',
        method: 'PUT'
    },
    'deleteItem': {
      url: config.apiBase + '/companies/:companyId/publications/:publicationId/orders/:orderId/items/:itemId',
      method: 'DELETE'
    },
    'copyOrder':  {
      url: config.apiBase + '/companies/:companyId/publications/:publicationId/orders/:orderId/copy',
      method: 'POST'
    },
  });
}

angular.module('dokiv')
  .factory('CompanyPublicationCompanyOrderService', ['$resource', 'config', CompanyPublicationCompanyOrderService]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/companyOrder/CompanyPublicationCompanyOrderService.js
// module id = 30
// module chunks = 0